import { Card, Elevation } from "@blueprintjs/core";
import fetch from "node-fetch";
import React from 'react';
import { withRouter } from 'react-router-dom';
import RentAgreementStepper from "../rent-agreement-stepper";
import AgreementPreview from '../rent-agreement/agreement-preview';
import PartyDetails from './party-details';
import RentPreview from './rent-preview';

class RentAgreementDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
      loaded: false,
      preview: true,
      paySuccess: false,
      partyDetails: false,
      complete: false,
      pay: false,
      currentStep: 1,
      locations: [],
      selectedLocation: {},
      data: {},
      values: {
        owner: {},
        tenant: {}
      }
    }
  }

  componentWillMount() {
    console.log(this.props.location);
    if (!this.props.location.data) {
      this.fetchLeaseDetails();
    } else {
      let step = (this.props.location.data.status === "Paid") ? 1 : 0;
      this.setState({ data: this.props.location.data, step, loaded: true });
    }
    this.fetchCities();
  }

  fetchCities() {
    let URL = '/v1/cities?stateUid=mh';
    fetch(URL)
      .then(response => response.json())
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        this.setState({ locations: result.data });
      });
  }

  fetchLeaseDetails = () => {
    let URL = `/v2/lease/detail?uid=${this.props.match.params.id}`;
    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.message !== 'Ok') {
          console.log(result.message);
          return;
        }
        if (result.data.status === "Paid") {
          if (result.data.parties.length > 0 || result.data.status === "BioConfirm") {
            this.setState({
              loaded: true,
              data: result.data,
              step: 2,
              currentStep: 3,
            });
          } else {
            this.setState({
              loaded: true,
              data: result.data,
              step: 1,
              currentStep: 2,
            })
          }
        } else if (result.data.status === "BioConfirm") {
          this.setState({
            loaded: true,
            data: result.data,
            step: 2,
            currentStep: 3,
          });
        } else if (result.data.status === "BioDone") {
          this.setState({
            loaded: true,
            data: result.data,
            step: 3,
            currentStep: 4,
          });
        } else {
          this.props.history.push({
            pathname: `/rentagreement/${result.data.uid}`
          });
        }
      });
  }

  getCity = (uid) => this.state.locations.filter(item => item.uid === uid)[0] || {};

  paymentSuccess = () => {
    // make payment process here
    this.setState({
      step: 1, currentStep: 2
    });
  }

  updateValues = (values) => {
    this.setState({ values });
  }

  rightContent = () => {
    if (this.state.step === 0) {
      return (
        <RentPreview
          data={this.state.data}
          paymentSuccess={this.paymentSuccess}
        />
      )
    } else if (this.state.step === 1) {
      return (
        <PartyDetails
          leaseUid={this.props.match.params.id}
          data={this.state.data}
          updateValues={this.updateValues}
          complete={() => {
            this.setState({ step: 2, currentStep: 3 });
            window.scroll(0, 0);
          }}
        />
      )
    } else if (this.state.step === 2) {
      return (
        <Card className="card" elevation={Elevation.ONE}>
          <div className="has-text-success has-text-centered has-text-weight-semibold is-size-6">
            <p>Congratulations!</p>
            <p>You have successfully completed the details for online rent agreement.</p>
            <p>Our representative will contact you for biometric appointment</p>
          </div>
        </Card>
      )
    } else if (this.state.step === 3) {
      return (
        <Card className="card" elevation={Elevation.ONE}>
          <div className="has-text-centered has-text-weight-semibold is-size-6">
            <a>Download the rent agreement!</a>
          </div>
        </Card>
      )
    }
  }

  render() {
    return (
      <section className="section">
        {this.state.loaded ?
          <div className="container">
            <RentAgreementStepper
              currentStep={this.state.currentStep} />
            <div className="columns">
              <div className="column is-6">
                <AgreementPreview values={this.state.values} selectedLocation={this.getCity(this.state.data.cityUid)} />
              </div>
              <div className="column is-6">
                <div className="rent-agreement-form">
                  <h2 className="is-size-4 level" style={{ marginBottom: "1rem" }}>
                    <span className="level-left">
                      <span className="level-item">Online Rent Agreement&nbsp;</span>
                    </span>
                    <span className="level-right">
                      {this.state.data.cityUid ?
                        <span className="level-item">({this.getCity(this.state.data.cityUid).name})</span> : null}
                    </span>
                  </h2>
                  <div>
                    {this.rightContent()}
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          null
        }
      </section>
    );
  }
}

export default withRouter(RentAgreementDetails);


// WEBPACK FOOTER //
// ./src/app/components/rent-agreement-details/index.js